function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z",
  fill: "#D679B0"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M40.0448 33.2527H34.3348V54.1715H25.6836V33.2527H21.5691V25.901H25.6836V21.1436C25.6836 17.7415 27.2996 12.4143 34.4118 12.4143L40.82 12.4411V19.5772H36.1704C35.4077 19.5772 34.3353 19.9582 34.3353 21.5811V25.9078H40.8006L40.0448 33.2527Z",
  fill: "white"
});
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.56b20447.svg";
export { ForwardRef as ReactComponent };